import { render, staticRenderFns } from "./WorkspaceUsersList.vue?vue&type=template&id=db5cd8c4&"
import script from "./WorkspaceUsersList.vue?vue&type=script&lang=js&"
export * from "./WorkspaceUsersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports